import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TooltipModule } from 'ngx-tooltip';
import { NgxSpinnerModule } from 'ngx-spinner';

/* Section omponents admin */
import { AdminRoutes } from './admin.routing';
import {
  AdminComponent,
  HeaderComponent,
  FooterComponent,
  NavbarComponent,
  SidebarComponent,
  MenuComponent,
  ContentComponent
} from "./";
import { SharedModule } from './shared.module';
import { ViewsModule } from './views/views.module';
import { AuthService } from '@app/services/auth.service';
import { EmpresaService } from '@app/services/empresa.service';
import { AlmacenesService } from '@app/services/almacenes.service';
import { FacturacionesService } from '@app/services/facturacion.service';

/* End section components admin */

@NgModule({
  declarations: [
    AdminComponent,
    MenuComponent,
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ContentComponent,
  ],
  imports: [
    CommonModule,
    ViewsModule,
    SharedModule,
    TooltipModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(AdminRoutes),
    //Ng4LoadingSpinnerModule.forRoot(),
    NgxSpinnerModule,
  ],
  exports: [
    RouterModule
  ],
  providers:[
    AuthService,
    EmpresaService,
    AlmacenesService,
    FacturacionesService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AdminModule { }
